/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HomeHealthCertificationStatus } from './HomeHealthCertificationStatus';
import {
    HomeHealthCertificationStatusFromJSON,
    HomeHealthCertificationStatusFromJSONTyped,
    HomeHealthCertificationStatusToJSON,
    HomeHealthCertificationStatusToJSONTyped,
} from './HomeHealthCertificationStatus';
import type { HomeHealthCertificationEncounterCandidate } from './HomeHealthCertificationEncounterCandidate';
import {
    HomeHealthCertificationEncounterCandidateFromJSON,
    HomeHealthCertificationEncounterCandidateFromJSONTyped,
    HomeHealthCertificationEncounterCandidateToJSON,
    HomeHealthCertificationEncounterCandidateToJSONTyped,
} from './HomeHealthCertificationEncounterCandidate';

/**
 * 
 * @export
 * @interface HomeHealthCertificationCriteriaF2fEncounterNote
 */
export interface HomeHealthCertificationCriteriaF2fEncounterNote {
    /**
     * 
     * @type {HomeHealthCertificationStatus}
     * @memberof HomeHealthCertificationCriteriaF2fEncounterNote
     */
    status: HomeHealthCertificationStatus;
    /**
     * 
     * @type {HomeHealthCertificationEncounterCandidate}
     * @memberof HomeHealthCertificationCriteriaF2fEncounterNote
     */
    strongest_candidate: HomeHealthCertificationEncounterCandidate;
    /**
     * 
     * @type {Array<HomeHealthCertificationEncounterCandidate>}
     * @memberof HomeHealthCertificationCriteriaF2fEncounterNote
     */
    alternatives: Array<HomeHealthCertificationEncounterCandidate>;
    /**
     * Encounter documents excluded from F2F eligibility because their encounter date is invalid or more than 90 days before the reference date.
     * @type {Array<HomeHealthCertificationEncounterCandidate>}
     * @memberof HomeHealthCertificationCriteriaF2fEncounterNote
     */
    expired_candidates: Array<HomeHealthCertificationEncounterCandidate>;
}



/**
 * Check if a given object implements the HomeHealthCertificationCriteriaF2fEncounterNote interface.
 */
export function instanceOfHomeHealthCertificationCriteriaF2fEncounterNote(value: object): value is HomeHealthCertificationCriteriaF2fEncounterNote {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('strongest_candidate' in value) || value['strongest_candidate'] === undefined) return false;
    if (!('alternatives' in value) || value['alternatives'] === undefined) return false;
    if (!('expired_candidates' in value) || value['expired_candidates'] === undefined) return false;
    return true;
}

export function HomeHealthCertificationCriteriaF2fEncounterNoteFromJSON(json: any): HomeHealthCertificationCriteriaF2fEncounterNote {
    return HomeHealthCertificationCriteriaF2fEncounterNoteFromJSONTyped(json, false);
}

export function HomeHealthCertificationCriteriaF2fEncounterNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationCriteriaF2fEncounterNote {
    if (json == null) {
        return json;
    }
    return {
        
        'status': HomeHealthCertificationStatusFromJSON(json['status']),
        'strongest_candidate': HomeHealthCertificationEncounterCandidateFromJSON(json['strongest_candidate']),
        'alternatives': ((json['alternatives'] as Array<any>).map(HomeHealthCertificationEncounterCandidateFromJSON)),
        'expired_candidates': ((json['expired_candidates'] as Array<any>).map(HomeHealthCertificationEncounterCandidateFromJSON)),
    };
}

export function HomeHealthCertificationCriteriaF2fEncounterNoteToJSON(json: any): HomeHealthCertificationCriteriaF2fEncounterNote {
    return HomeHealthCertificationCriteriaF2fEncounterNoteToJSONTyped(json, false);
}

export function HomeHealthCertificationCriteriaF2fEncounterNoteToJSONTyped(value?: HomeHealthCertificationCriteriaF2fEncounterNote | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': HomeHealthCertificationStatusToJSON(value['status']),
        'strongest_candidate': HomeHealthCertificationEncounterCandidateToJSON(value['strongest_candidate']),
        'alternatives': ((value['alternatives'] as Array<any>).map(HomeHealthCertificationEncounterCandidateToJSON)),
        'expired_candidates': ((value['expired_candidates'] as Array<any>).map(HomeHealthCertificationEncounterCandidateToJSON)),
    };
}

